import { useState } from 'react';

const faqs = [
  {
    q: 'Is KSS BillBook GST and e-Invoice compliant?',
    a: 'Yes — we generate IRN + QR via the GSTN sandbox / production gateway, support B2B / B2C invoices, e-Way Bill (Part-A & Part-B), HSN/SAC summaries and GSTR-1 export.',
  },
  {
    q: 'How long does setup take?',
    a: 'Most single-branch businesses are live within a week. Larger multi-branch groups typically take 2–3 weeks including data migration, user training and printer/POS hardware setup.',
  },
  {
    q: 'Can I import data from Tally / Marg / Busy / QuickBooks?',
    a: 'Yes. CSV import is built-in for products, customers, suppliers, opening stock and opening balances. Migration assistance is included on Growth and Business plans.',
  },
  {
    q: 'Does it work offline at the POS?',
    a: 'Yes. The POS terminal queues bills locally if the internet drops and auto-syncs once it reconnects, so you never miss a sale.',
  },
  {
    q: 'How is multi-branch billing handled?',
    a: 'You pay per active branch. Each branch gets its own users, terminals and inventory; reports roll up across branches automatically. Add or pause branches anytime.',
  },
  {
    q: 'Is my data secure and isolated?',
    a: 'Every tenant is logically isolated; data is encrypted at rest and in transit. Role-based access, MFA, refresh-token rotation and a tamper-evident audit log are built in.',
  },
  {
    q: 'Do you have an API?',
    a: 'Yes — a REST API with 280+ resources, OpenAPI documentation, webhooks and API keys. Build integrations or run BillBook as the back-end for your own apps.',
  },
  {
    q: 'What if I want to cancel?',
    a: 'You can cancel anytime from inside the app. Your data stays accessible (read-only) for 90 days, and you can export a full backup as CSV/JSON whenever you want.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
      <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">Frequently asked</h2>
      <p className="mt-2 text-sm text-[var(--color-text-secondary)] sm:text-base">
        Got a question we didn&rsquo;t answer? <a href="#" className="text-[var(--color-primary)] hover:underline">Contact us</a> — we usually reply within an hour.
      </p>
      <div className="mt-8 divide-y divide-[var(--color-border)] rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-card)]">
        {faqs.map((f, i) => (
          <div key={f.q}>
            <button
              type="button"
              onClick={() => setOpen(open === i ? null : i)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-sm font-medium"
            >
              <span>{f.q}</span>
              <span className="text-[var(--color-text-secondary)]">{open === i ? '−' : '+'}</span>
            </button>
            {open === i && (
              <p className="px-5 pb-4 text-sm text-[var(--color-text-secondary)]">{f.a}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
